<form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
  <div class="text-center mb-11">

    <h1 class="text-dark font-bold mb-4">Update Password</h1>
  </div>
  <div class="w-full mb-8 flex flex-col">
    <label for="password" class="form-label !text-dark">New Password</label>
    <input
      pInputText
      class="form-control !bg-transparent"
      id="password"
      type="password"
      formControlName="password"
      placeholder="Enter new password"
      (input)="validatePassword($event)"
      [ngClass]="{
        'is-invalid': resetPasswordForm.controls['password'].invalid,
        'is-valid': resetPasswordForm.controls['password'].valid
      }"
    />
  </div>
  <div class="w-full mb-2">
    <ul>
      <li [class.valid]="hasNumber" class="flex gap-2 items-center">
        @if(hasNumber){<i
          class="fa fa-solid fa-check text-xl font-semibold text-success"
        ></i>

        }@else {
        <i class="fa-solid fa-xmark text-xl font-semibold text-danger"></i>
        } Contains at least one digit
      </li>

      <li [class.valid]="hasLowercase" class="flex gap-2 items-center">
        @if(hasLowercase){<i
          class="fa fa-solid fa-check text-xl text-success font-semibold"
        ></i>

        }@else {
        <i class="fa-solid fa-xmark text-xl font-semibold text-danger"></i>
        } Contains at least one lowercase letter
      </li>
      <li [class.valid]="hasUppercase" class="flex gap-2 items-center">
        @if(hasUppercase){<i
          class="fa fa-solid fa-check text-xl text-success font-semibold"
        ></i>

        }@else {
        <i class="fa-solid fa-xmark text-xl font-semibold text-danger"></i>
        } Contains at least one uppercase letter
      </li>
      <li [class.valid]="hasNoSpaces" class="flex gap-2 items-center">
        @if(hasNoSpaces){<i
          class="fa fa-solid fa-check text-xl text-success font-semibold"
        ></i>

        }@else {
        <i class="fa-solid fa-xmark text-xl font-semibold text-danger"></i>
        } No spaces
      </li>
      <li [class.valid]="hasValidLength" class="flex gap-2 items-center">
        @if(hasValidLength){<i
          class="fa fa-solid fa-check text-xl text-success font-semibold"
        ></i>

        }@else {
        <i class="fa-solid fa-xmark text-xl font-semibold text-danger"></i>
        } Minimum 8 characters
      </li>
    </ul>
  </div>
  <div class="w-full mt-5 mb-8 flex flex-col">
    <label class="form-label fs-6 font-bold text-dark" for="confirmPassword"
      >Confirm Password</label
    >
    <input
      pInputText
      class="form-control !bg-transparent"
      type="password"
      formControlName="confirmPassword"
      placeholder="Confirm new password"
      [ngClass]="{
        'is-invalid': resetPasswordForm.controls['confirmPassword'].invalid,
        'is-valid': resetPasswordForm.controls['confirmPassword'].valid
      }"
    />
    @if ( resetPasswordForm.errors?.['notMatching'] &&
    resetPasswordForm.get('confirmPassword')?.touched ) {
    <div class="flex gap-2 items-center mt-2 text-danger">
      <i class="fa fa-solid fa-xmark text-xl text-danger font-semibold"></i>
      Passwords do not match
    </div>
    }
  </div>

  <div class="w-full">
    <button
      pButton
      type="submit"
      class="w-full"
      [disabled]="resetPasswordForm.invalid"
    >
      @if (isLoading$ | async) {
      <span class="indicator-progress" [style.display]="'block'">
        Please wait...
        <span class="spinner-border spinner-border-sm align-middle ml-2"></span>
      </span>
      } @if ((isLoading$ | async) === false) {
      <span class="indicator-label">Continue</span>
      }
    </button>
  </div>
</form>
